import { render, staticRenderFns } from "./TrainingDataChange.vue?vue&type=template&id=d3220266&scoped=true&"
import script from "./TrainingDataChange.vue?vue&type=script&lang=js&"
export * from "./TrainingDataChange.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDataChange.vue?vue&type=style&index=0&id=d3220266&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3220266",
  null
  
)

export default component.exports